/* global axios */
import ApiClient from './ApiClient';

class ConversationWorkflowsAPI extends ApiClient {
  constructor() {
    super('conversation_workflows', { accountScoped: true });
  }

  executions(workflowId) {
    return axios.get(`${this.url}/${workflowId}/executions`);
  }

  executionShow(workflowId, executionId) {
    return axios.get(`${this.url}/${workflowId}/executions/${executionId}`);
  }

  executionDelete(workflowId, executionId) {
    return axios.delete(`${this.url}/${workflowId}/executions/${executionId}`);
  }
}

export default new ConversationWorkflowsAPI();
